import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';

const FOCUSABLE_SELECTOR = 'input[type="number"]';

@Directive({
    selector: '[libBlurFocusedOnWheel]'
})
export class BlurFocusedOnWheelDirective implements OnInit, OnDestroy {
    private readonly elementRef = inject(ElementRef<HTMLElement>);

    private readonly onWheel = (event: WheelEvent): void => {
        const active = document.activeElement as HTMLElement | null;
        const host = this.elementRef.nativeElement;

        if (!active || active === host || !host.contains(active) || !active.matches(FOCUSABLE_SELECTOR)) {
            return;
        }

        if (active.matches('input[type="number"]')) {
            event.preventDefault();
        }

        active.blur();
    };

    ngOnInit(): void {
        this.elementRef.nativeElement.addEventListener('wheel', this.onWheel, { capture: true, passive: false });
    }

    ngOnDestroy(): void {
        this.elementRef.nativeElement.removeEventListener('wheel', this.onWheel, { capture: true });
    }
}
